
export default {
	name: 'TaskCategoriesLookup',
	options: {
		tablename: 'v_categories',
		schema: 'cabsav'
	}
};

